import { Link, NavLink } from "react-router-dom";
import { ArrowDown } from "lucide-react";
import Socials from "./Socials";
import { NAV_ITEMS, TAGLINE } from "@/data/content";

export default function Sidebar() {
    return (
        <aside className="hidden lg:flex fixed inset-y-0 left-0 z-40 w-72 xl:w-80 flex-col bg-ink text-paper2 px-8 xl:px-10 py-8">
            <Link
                to="/"
                data-testid="sidebar-wordmark"
                className="mono text-lg font-bold tracking-tight"
            >
                _beingdevang<span className="blink text-sage">_</span>
            </Link>

            <nav className="mt-12 flex flex-col gap-1" data-testid="sidebar-nav">
                {NAV_ITEMS.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        end={item.path === "/"}
                        data-testid={`nav-link-${item.id}`}
                        className={({ isActive }) =>
                            `group flex items-center gap-3 px-3 py-2 mono text-sm tracking-wide transition-all duration-300 ${
                                isActive
                                    ? "bg-sage text-ink"
                                    : "text-paper2/60 hover:text-paper"
                            }`
                        }
                    >
                        <span className="text-xs opacity-50">|</span>
                        {item.label}
                    </NavLink>
                ))}
            </nav>

            <div className="my-8 h-px bg-paper2/15" />

            <p className="text-sm leading-relaxed text-paper2/55 max-w-[28ch]">
                {TAGLINE}
            </p>

            <div className="mt-6">
                <Socials />
            </div>

            <div className="mt-auto flex items-center gap-3 text-paper2/45">
                <ArrowDown className="h-3.5 w-3.5 animate-bounce" />
                <span className="mono text-[10px] tracking-[0.25em]">
                    SCROLL TO EXPLORE
                </span>
            </div>
        </aside>
    );
}
